import { rootStore } from "@/mobx/store";

type PaymentLink = { txId: string; accessToken: string };

/**
 * 결제 링크(txId·accessToken). 주소창 값을 먼저 쓰고, 결제 앱을 다녀오거나 화면을 옮긴 뒤에는 세션에 저장한 값을 쓴다.
 * 게이트웨이는 결제창 조회에서 이 토큰을 링크 증명으로 본다 — 다른 청구서의 토큰은 섞지 않는다.
 */
export const paymentLink = (
  search: string = window.location.search,
  saved: Partial<PaymentLink> | null = rootStore.getPaymentInfo
): PaymentLink => {
  const params = new URLSearchParams(search);
  const txId = params.get("txId") || saved?.txId || "";
  const accessToken = params.get("accessToken") || (saved?.txId === txId ? saved?.accessToken : "") || "";
  return { txId, accessToken };
};

/** 결제창 안에서 화면을 옮길 때 붙이는 쿼리 — 토큰을 잃지 않게 한다. */
export const paymentLinkQuery = ({ txId, accessToken }: PaymentLink) => {
  const query = new URLSearchParams({ txId });
  if (accessToken) query.set("accessToken", accessToken);
  return query.toString();
};
